module.exports = __webpack_public_path__ + "media/images/hero-bg-93eb4454f7b28ad92acb3e8a67ae639c.png";